import template from './DeleteFunctionModalView.html';
import controller from './DeleteFunctionModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            ...params.inputs,
            modalClass: params.modalClass || '',
            size: params.size || 'sm',
            confirm: params.confirm,
            actions: params.actions,
            applications: params.applications,
        },
    };
};
